module.exports = __webpack_public_path__ + "img/ic_publicity_detail9_8.b6536ffb.png";